// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const CHANGE_OPEN_PANEL = 'CHANGE_OPEN_PANEL'
export const CLEAR_PROJECT_SUMMARY = 'CLEAR_PROJECT_SUMMARY'
export const DISABLE_PROJECT_FILTER = 'DISABLE_PROJECT_FILTER'
export const DISABLE_PROJECT_MENU = 'DISABLE_PROJECT_MENU'
export const ENABLE_PROJECT_FILTER = 'ENABLE_PROJECT_FILTER'
export const ENABLE_PROJECT_MENU = 'ENABLE_PROJECT_MENU'
export const FETCH_PROJECT_ERROR = 'FETCH_PROJECT_ERROR'
export const FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS'
export const FETCHING_PROJECT = 'FETCHING_PROJECT'
export const PROJECT_SUMMARY_MODAL_CLOSE = 'PROJECT_SUMMARY_MODAL_CLOSE'
export const PROJECT_SUMMARY_MODAL_OPEN = 'PROJECT_SUMMARY_MODAL_OPEN'
export const UPDATE_COMPANIES = 'UPDATE_COMPANIES'
export const UPDATE_HIGHLIGHTED_PATHS = 'UPDATE_HIGHLIGHTED_PATHS'
export const UPDATE_MODAL_ERROR = 'UPDATE_MODAL_ERROR'
export const UPDATE_MODAL_MESSAGE = 'UPDATE_MODAL_MESSAGE'
export const UPDATE_MODAL_PATH_SET = 'UPDATE_MODAL_PATH_SET'
export const UPDATE_PROJECT_FILTER = 'UPDATE_PROJECT_FILTER'
export const UPDATE_PATHS = 'UPDATE_PATHS'
export const UPDATE_PROJECT_SETTINGS = 'UPDATE_PROJECT_SETTINGS'
export const UPDATE_PROJECT_SORT = 'UPDATE_PROJECT_SORT'
export const UPDATE_VISIBLE_PATHS = 'UPDATE_VISIBLE_PATHS'
